import { Layout, Text } from '@loadsmart/miranda-react'

export type InformationProps = {
  locationInfo: string
  dateInfo: string
  facilityName?: string
}

export function Information({ locationInfo, dateInfo, facilityName }: InformationProps) {
  return (
    <Layout.Stack gap="none">
      <Text variant="body-md-bold" color="color-text-primary">
        {locationInfo}
      </Text>
      {facilityName && (
        <Text variant="body-sm" color="color-text-secondary">
          {facilityName}
        </Text>
      )}
      <Text variant="body-sm" color="color-text-tertiary">
        {dateInfo}
      </Text>
    </Layout.Stack>
  )
}
